import { useState, useCallback, useEffect, useRef } from 'react';

/**
 * use composite state
 * @template T
 * @param {T} initialState
 * @returns {[T, (cb: {[Property in keyof T]?: any;} | ((draft: {[Property in keyof T]?: any;}) => T | void)) => Promise]}
 */
export default function useCompositeState (initialState) {
	// 必须传入对象
	if (Object.prototype.toString.call(initialState) !== '[object Object]') {
		throw new TypeError('useCompositeState\'s param(initialState) should be a object');
	}
	// 根据初始值得到 state和setState
	const [state, setState] = useState(initialState);
	// 保存promise的resolve
	const resolveRef = useRef();
	// 替换setState
	const modifyState = useCallback(
		(cb) => {
			return new Promise(resolve => {
				if (typeof cb === 'function') {
					setState(prevState => {
						const ret = cb(prevState);
						const resultType = Object.prototype.toString.call(ret).slice(8, -1);
						if (resultType === 'Object') {
							return { ...Object.assign(prevState, ret) };
						} else if (resultType === 'Undefined') {
							return { ...prevState };
						}
						throw new TypeError('useCompositeState\'s setState should return a object or undefined');
					});
				} else if (typeof cb === 'object') {
					setState(state => ({ ...state, ...cb }));
				}
				resolveRef.current = resolve;
			});
		},
		[]
	);

	useEffect(() => {
		if (resolveRef.current) {
			resolveRef.current?.();
			resolveRef.current = null;
		}
	});

	return [state, modifyState];
}
